export default {
  path: '/qr-code',
  component: () => import('@/views/qrCodes/index.vue'),
  children: [
    {
      path: '',
      name: 'QrCode',
      component: () => import('@/views/qrCodes/pages/qrCode.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'developer',
          'support',
          'warehouse_manager',
          'marketing',
          'warehouse',
          'store_manager',
          'accounting_manager',
          'acting_assist_store_manager',
          'assist_store_manager',
          'sales_staff'
        ]
      }
    },
    {
      path: '/print-a4',
      name: 'QRcodeA4Page',
      component: () => import('@/views/qrCodes/pages/qrCodeA4Page.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'developer',
          'accounting_manager',
          'support',
          'warehouse_manager',
          'marketing',
          'warehouse',
          'store_manager',
          'acting_assist_store_manager',
          'assist_store_manager',
          'sales_staff'
        ],
        layout: 'Blank'
      }
    },
    {
      path: '/print-godex',
      name: 'QRcodeGodexPage',
      component: () => import('@/views/qrCodes/pages/qrCodeGodexPage.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'developer',
          'support',
          'warehouse_manager',
          'marketing',
          'accounting_manager',
          'warehouse',
          'store_manager',
          'acting_assist_store_manager',
          'assist_store_manager',
          'sales_staff'
        ],
        layout: 'Blank'
      }
    }
  ]
}
